<script setup lang="ts">
import { computed } from 'vue';
import type { FieldSchema } from '../../../types';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: string | boolean;
    field?: FieldSchema;
    isInlineEditing?: boolean;
    placeholder?: string;
    required?: boolean;
  }>(),
  {
    isInlineEditing: false,
    placeholder: 'components.forms.placeholder.common',
  }
);

const model = defineModel<string | undefined>();

const settings = computed(() => props?.field?.settings);
const _disabled = computed(() => {
  if (props.field?.state?.disabled) return props.field?.state.disabled;

  return settings.value?.editable ? !settings.value?.editable : props.disabled;
});

function handleInput(event: Event) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/\D/g, '');

  const maxLength = String(9999).length;
  if (input.value.length > maxLength) input.value = input.value.slice(0, maxLength);

  model.value = input.value;
}
</script>

<template>
  <InputText
    v-model="model"
    type="text"
    :class="['h-9 w-full text-sm', { 'af-field-error': !!error }]"
    :disabled="_disabled"
    :invalid="!!error"
    :placeholder="$t(settings?.placeholder || placeholder || $t('cart.label.lastFourPlaceholder'))"
    :required="settings?.required || required"
    @input="handleInput"
  />
</template>
